import React, { memo } from 'react';
import { useParams } from 'react-router-dom';

import { DetailContainer } from './DetailContainer';
import { NotConnected } from './ListContainer';

export const MobileContainer = memo(() => {
  const { id } = useParams<{ id: string }>() || {};
  return <>{id ? <DetailContainer id={id} /> : <NotConnected />}</>;
});
